import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "../slice/auth/authSlice";

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/api/v1`,
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.token || localStorage.getItem('token');

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    headers.set("Content-Type", "application/json");
    return headers;
  },
});



export const baseQueryWithAuthLogout = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  const isInvalidToken =
    // result?.error?.status === 401 ||
    result?.error?.data?.message === "Invalid token" ||
    result?.error?.data?.error === "invalid_token";

  if (isInvalidToken) {
    api.dispatch(logout());
    localStorage.removeItem('token')
    window.location.href = "/login";
  }

  return result;
};